export default {
    companyData: {
        phone: '13888888888',
        location: '杭州市西湖区蓝海国际大厦1号楼 A12A13',
        name: '杭州栗鼠科技有限公司',
        english: 'Hangzhou chinchilla Technology Co., Ltd',
        // qrCodeImgUrl: require('@/assets/images/about-us-banner-title.png')
    }
}


// WEBPACK FOOTER //
// ./src/utils/companyMsg.js